import { ed25519, x25519 } from "@noble/curves/ed25519.js";
import { fromBase64, toBase64 } from "./base64.js";
export function newDeviceSecrets() {
    return {
        signing: toBase64(ed25519.utils.randomSecretKey()),
        encryption: toBase64(x25519.utils.randomSecretKey()),
    };
}
/** The public keys a device registers at sign-in. */
export function publicKeysOf(secrets) {
    return {
        signing_key: toBase64(ed25519.getPublicKey(fromBase64(secrets.signing))),
        encryption_key: toBase64(x25519.getPublicKey(fromBase64(secrets.encryption))),
    };
}
export function sign(bytes, signingSecret) {
    return ed25519.sign(bytes, fromBase64(signingSecret));
}
/** False for a wrong signature, a wrong key or malformed input; never throws on bad data. */
export function verify(bytes, signature, signingKey) {
    try {
        return ed25519.verify(fromBase64(signature), bytes, fromBase64(signingKey));
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=keys.js.map